// Карточки интеграций живут в двух местах: на странице «Интеграции» - как самостоятельные
// Card, и внутри мастера настройки - вложенными в Card самого шага.
//
// Во втором случае карточка в карточке даёт тень поверх тени и двойной отступ в 5+5, поэтому
// встроенный вариант перекрашивается в ту же плашку, что и остальные блоки мастера
// (`rounded-md border border-line bg-panel2/40 p-3`). Классы держим здесь, а не в трёх
// компонентах: иначе при первой же правке они разойдутся.

import { cn } from '@smena/ui';

/** Общий проп для карточек, которые умеют показываться внутри шага мастера. */
export interface EmbeddableCardProps {
  /** true - рендер без собственной card-обвязки, плашкой внутри чужой карточки. */
  embedded?: boolean;
}

// Фон намеренно прозрачный, а не panel2/40: внутри карточек есть свои плашки (форма фида,
// отчёт импорта) именно на panel2/40, и одинаковая заливка слепила бы их с контейнером.
export function embedCard(embedded: boolean | undefined, extra?: string): string | undefined {
  return cn(embedded && 'rounded-md bg-transparent shadow-none', extra) || undefined;
}

export function embedHeader(embedded: boolean | undefined, extra?: string): string | undefined {
  return cn(embedded && 'p-3 pb-2', extra) || undefined;
}

export function embedContent(embedded: boolean | undefined, extra?: string): string | undefined {
  return cn(extra, embedded && 'p-3 pt-0') || undefined;
}
